module.exports = __webpack_public_path__ + "static/sample-6-a494b898dcc9609acaa1f0b5ba4820ac.png";